import validators from '../../utils/validators';

class CheckupField {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      label: (v) => validators.isString(v),
      type: (v) => validators.isNotEmptyStringOrNull(v),
      sort: (v) => validators.isNumber(v),
      level: (v) => validators.isNumber(v),
      note: (v) => validators.isNotEmptyStringOrNull(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid CheckupField property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }

    const levels = [80, 60, 40, 20, 1];
    const level = levels.find(l => l <= this.level);

    this.strength = typeof level === 'number' ? level : 0;
  }
}

export default CheckupField;
